import { atom, selector } from 'recoil';

import { StoreQuery, StoreDocument, StoreQueryVariables } from './graphql';
import { createQuerySelector } from '../utils/createQuerySelector';
import { persistAtom } from '../utils/persistAtom';

export const GLOBAL_STORE_ID = 995;

export const storeIdState = atom<number>({
	key: 'storeId',
	default: 995,
	effects_UNSTABLE: [
		persistAtom
		// ({ onSet }) => {
		// 	onSet(newID => {
		// 		// console.debug('Current store ID:', newID);
		// 	});
		// }
	]
});

export const storeQueryVariablesState = selector<StoreQueryVariables>({
	key: 'storeQueryVariables',
	get({ get }) {
		const storeId = get(storeIdState);

		// console.debug('Current storeQueryVariables ID:', { storeId });
		return { storeId };
	}
});

export const storeQueryState = createQuerySelector<
	StoreQuery,
	StoreQueryVariables
>('storeQuery', StoreDocument, storeQueryVariablesState, true);

export const isStoreGlobalState = selector<boolean>({
	key: 'isStoreGlobal',
	get({ get }) {
		const storeId = get(storeIdState);

		return storeId === GLOBAL_STORE_ID;
	}
});

export const storeState = selector<StoreQuery['store'] | undefined>({
	key: 'store',
	get({ get }) {
		const store = get(storeQueryState)?.data.store;

		return store;
	}
});

export const regionIdState = selector<number>({
	key: 'regionId',
	get({ get }) {
		const store = get(storeState);

		return store?.regionId ?? 0;
	}
});
